"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indicatorSchema = void 0;
var constants_1 = require("../../constants");
exports.indicatorSchema = {
    type: 'object',
    required: [
        'claimProcessingUnitType',
        'claimReceivedDate',
        'eddFemsi',
        'editsAndAllowances',
        'enhancedAcpp',
        'notepadComment',
        'paymentCount',
        'rffi',
        'underwritingReview',
    ],
    properties: {
        claimProcessingUnitType: {
            type: 'integer',
            enum: Object.values(constants_1.ClaimProcessUnitTypeEnum),
            errorMessage: 'should be a valid LegalActionType Enum value',
        },
        claimReceivedDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        eddFemsi: {
            type: 'boolean',
            errorMessage: 'should be between true or false',
        },
        editsAndAllowances: {
            type: 'boolean',
            errorMessage: 'should be between true or false',
        },
        enhancedAcpp: {
            type: 'boolean',
            errorMessage: 'should be between true or false',
        },
        gvsPvii: {
            type: 'boolean',
            errorMessage: 'should be between true or false',
        },
        paymentCount: {
            type: 'number',
            minimum: 0,
            maximum: 400,
            errorMessage: 'should be numeric between 0 and 400',
        },
        rffi: {
            type: 'boolean',
            errorMessage: 'should be between true or false',
        },
        underwritingInformationReceivedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        underwritingInformationRequestedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        underwritingReview: {
            type: 'boolean',
            errorMessage: 'should be between true or false',
        },
        underwritingReviewEndDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        underwritingReviewStartDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
    },
};
exports.default = exports.indicatorSchema;
